export const getFormattedFilters = state => objectKey => {
    return _.mapValues(state.filters[objectKey], function(val, key){
        if (val !== null && typeof val === 'object' && typeof val.value !== 'undefined') {
            return val.value;
        }
        return val;
    });
}
